<template>
  <div class="cloud-disk-sms-records">
    <div class="search-bar">
      <el-input
        v-model.trim="query.batchNo"
        clearable
        size="small"
        placeholder="批次号"
        style="width: 210px"
        @keyup.enter.native="search"
      />
      <el-input
        v-model.trim="orderIdInput"
        clearable
        size="small"
        placeholder="订单ID"
        style="width: 150px"
        @keyup.enter.native="search"
      />
      <el-input
        v-model.trim="query.mobileLast4"
        clearable
        size="small"
        maxlength="4"
        placeholder="手机号后四位"
        style="width: 150px"
        @keyup.enter.native="search"
      />
      <el-select
        v-model="query.businessResult"
        clearable
        size="small"
        placeholder="业务结果"
        style="width: 145px"
      >
        <el-option label="开通成功" value="SUCCESS" />
        <el-option label="开通失败" value="FAILURE" />
      </el-select>
      <el-select
        v-model="query.sendStatus"
        clearable
        size="small"
        placeholder="下发状态"
        style="width: 135px"
      >
        <el-option label="待下发" value="PENDING" />
        <el-option label="下发成功" value="SUCCESS" />
        <el-option label="下发失败" value="FAILURE" />
      </el-select>
      <el-button
        type="primary"
        size="small"
        icon="el-icon-search"
        @click="search"
        >查询</el-button
      >
      <el-button size="small" @click="reset">重置</el-button>
    </div>

    <el-table v-loading="loading" :data="rows" border stripe height="100%">
      <el-table-column prop="id" label="记录ID" width="90" />
      <el-table-column
        prop="orderNo"
        label="订单号"
        min-width="170"
        show-overflow-tooltip
      />
      <el-table-column prop="mobile" label="手机号" width="125" />
      <el-table-column label="业务结果" width="105" align="center">
        <template slot-scope="scope">
          <el-tag
            :type="
              scope.row.businessResult === 'SUCCESS' ? 'success' : 'warning'
            "
            size="small"
          >
            {{ businessResultText(scope.row.businessResult) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="下发状态" width="105" align="center">
        <template slot-scope="scope">
          <el-tag :type="sendStatusType(scope.row.sendStatus)" size="small">
            {{ sendStatusText(scope.row.sendStatus) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="content"
        label="短信内容"
        min-width="260"
        show-overflow-tooltip
      />
      <el-table-column
        prop="portName"
        label="下发端口"
        min-width="120"
        show-overflow-tooltip
      />
      <el-table-column
        prop="batchNo"
        label="批次号"
        min-width="190"
        show-overflow-tooltip
      >
        <template slot-scope="scope">{{ scope.row.batchNo || "-" }}</template>
      </el-table-column>
      <el-table-column label="平台返回" min-width="200" show-overflow-tooltip>
        <template slot-scope="scope">{{ providerResult(scope.row) }}</template>
      </el-table-column>
      <el-table-column
        prop="operator"
        label="操作人"
        min-width="120"
        show-overflow-tooltip
      />
      <el-table-column label="下发时间" width="165">
        <template slot-scope="scope">{{
          formatTime(scope.row.sentTime || scope.row.createdTime)
        }}</template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="90" align="center">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.sendStatus === 'FAILURE'"
            type="text"
            :loading="resendingId === scope.row.id"
            @click="resend(scope.row)"
            >补发</el-button
          >
          <span v-else>-</span>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <el-pagination
        :current-page="query.page"
        :page-size="query.size"
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @current-change="changePage"
        @size-change="changeSize"
      />
    </div>
  </div>
</template>

<script>
import { queryCloudDiskSmsRecords, resendCloudDiskSms } from "@/api/yunpan";

export default {
  name: "CloudDiskSmsRecords",
  data() {
    return {
      loading: false,
      resendingId: null,
      rows: [],
      total: 0,
      orderIdInput: "",
      query: {
        batchNo: "",
        orderId: null,
        mobileLast4: "",
        businessResult: "",
        sendStatus: "",
        page: 1,
        size: 20,
      },
    };
  },
  created() {
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        const response = await queryCloudDiskSmsRecords(this.query);
        this.rows = response.data.content || [];
        this.total = response.data.total || 0;
      } finally {
        this.loading = false;
      }
    },
    search() {
      if (this.orderIdInput && !/^\d+$/.test(this.orderIdInput)) {
        return this.$message.warning("订单ID只能输入数字");
      }
      if (this.query.mobileLast4 && !/^\d{4}$/.test(this.query.mobileLast4)) {
        return this.$message.warning("请输入手机号后四位");
      }
      this.query.orderId = this.orderIdInput ? Number(this.orderIdInput) : null;
      this.query.page = 1;
      this.load();
    },
    reset() {
      this.orderIdInput = "";
      this.query = {
        batchNo: "",
        orderId: null,
        mobileLast4: "",
        businessResult: "",
        sendStatus: "",
        page: 1,
        size: 20,
      };
      this.load();
    },
    changePage(page) {
      this.query.page = page;
      this.load();
    },
    changeSize(size) {
      this.query.size = size;
      this.query.page = 1;
      this.load();
    },
    async resend(row) {
      await this.$confirm(
        `确认补发订单 ${
          row.orderNo || row.orderId
        } 的短信吗？补发会新增一条下发记录。`,
        "短信补发确认",
        { type: "warning" }
      );
      this.resendingId = row.id;
      try {
        await resendCloudDiskSms(row.id);
        this.$message.success("短信补发处理完成");
        this.load();
      } finally {
        this.resendingId = null;
      }
    },
    businessResultText(value) {
      return value === "SUCCESS"
        ? "开通成功"
        : value === "FAILURE"
        ? "开通失败"
        : value || "-";
    },
    sendStatusText(value) {
      const text = {
        PENDING: "待下发",
        SUCCESS: "下发成功",
        FAILURE: "下发失败",
      };
      return text[value] || value || "-";
    },
    sendStatusType(value) {
      return value === "SUCCESS"
        ? "success"
        : value === "FAILURE"
        ? "danger"
        : "info";
    },
    providerResult(row) {
      return (
        [row.providerCode || "", row.providerMessage || ""]
          .filter(Boolean)
          .join(" / ") || "-"
      );
    },
    formatTime(value) {
      return value ? String(value).replace("T", " ") : "-";
    },
  },
};
</script>

<style scoped>
.cloud-disk-sms-records {
  height: calc(100vh - 180px);
  display: flex;
  flex-direction: column;
}
.search-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 14px;
  align-items: center;
}
.pagination {
  display: flex;
  justify-content: flex-end;
  padding-top: 14px;
}
</style>
